import React from 'react';

const PergolasProjects: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Recent Pergola Installations</h2>
          <p className="text-xl text-gray-600">See our latest projects across Ontario</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="images/pergolas/pic1.webp" 
              alt="Mississauga pergola installation - Premium motorized model" 
              className="w-full h-48 object-cover"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">Mississauga - Premium Model</h3>
              <p className="text-gray-600">
                Premium motorized pergola with smart LED lighting. Perfect for year-round entertaining.
              </p>
              <div className="mt-4 text-sm text-accent font-semibold">Installed: August 2024</div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="images/pergolas/pic2.webp" 
              alt="Burlington pergola installation - Premium model" 
              className="w-full h-48 object-cover"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">Burlington - Premium Model</h3>
              <p className="text-gray-600">
                Elegant pergola installation with integrated screens and heating elements.
              </p>
              <div className="mt-4 text-sm text-accent font-semibold">Installed: July 2024</div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="images/pergolas/pic3.webp" 
              alt="Toronto pergola installation - previous manual model"
              className="w-full h-48 object-cover"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-primary mb-2">Previous Manual Model</h3>
              <p className="text-gray-600">
                A previously offered manual pergola providing excellent shade and weather protection.
              </p>
            </div>
          </div>
        </div>

        {/* Customer Testimonials */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-primary text-center mb-12">What Our Customers Say</h3>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-4">
                <span className="text-3xl mr-3">👨‍💼</span>
                <div className="text-yellow-400">★★★★★</div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "The motorized pergola has transformed our backyard into a year-round entertainment space. 
                The installation was professional and the quality is outstanding."
              </p>
              <p className="text-primary font-semibold">— Michael & Sarah C., Mississauga</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-4">
                <span className="text-3xl mr-3">👩‍🦳</span>
                <div className="text-yellow-400">★★★★★</div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "We love our starter pergola! It provides perfect shade for our deck and the manual 
                louvers are easy to adjust. Great value for the price."
              </p>
              <p className="text-primary font-semibold">— Linda M., Burlington</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PergolasProjects;
